import { GroupId } from '../../typings/groups';

export const ON_CLOSE_BANNER_PREVIEW_POPUP = 'ON_CLOSE_BANNER_PREVIEW_POPUP';
export type ON_CLOSE_BANNER_PREVIEW_POPUP = typeof ON_CLOSE_BANNER_PREVIEW_POPUP;

export interface OnCloseBannerPreviewPopup {
    type: ON_CLOSE_BANNER_PREVIEW_POPUP;
    id: GroupId;
}

export function onCloseBannerPreviewPopup(id: GroupId): OnCloseBannerPreviewPopup {
    return {
        type: ON_CLOSE_BANNER_PREVIEW_POPUP,
        id
    };
}

export const ON_OPEN_BANNER_PREVIEW_POPUP = 'ON_OPEN_BANNER_PREVIEW_POPUP';
export type ON_OPEN_BANNER_PREVIEW_POPUP = typeof ON_OPEN_BANNER_PREVIEW_POPUP;

export interface OnOpenBannerPreviewPopup {
    type: ON_OPEN_BANNER_PREVIEW_POPUP;
    id: GroupId;
}

export function onOpenBannerPreviewPopup(id: GroupId): OnOpenBannerPreviewPopup {
    return {
        type: ON_OPEN_BANNER_PREVIEW_POPUP,
        id
    };
}

export type GroupsEditPreviewBannersAction = OnCloseBannerPreviewPopup | OnOpenBannerPreviewPopup;
